import React, { useContext, useState, useEffect } from 'react';
import { EntitiesContext, UserContext } from '../../App';
import { useGetAccountAddress, useUpdateAccount } from '../../hooks/useAccount';
import { useUpdateAddress } from '../../hooks/useAddress';
import { formatPhone, toTitleCase } from '../../constants/helpers';

export default function Profile() {
  const user = useContext(UserContext);
  const entities = useContext(EntitiesContext);
  const [profile, setProfile] = useState(user.user);
  const [errors, setErrors] = useState([]);
  const [address, setAddress] = useState();
  const [updated, setUpdated] = useState(false);

  const getAddress = useGetAccountAddress();
  const updateAddress = useUpdateAddress();
  const updateAccount = useUpdateAccount();

  useEffect(() => {
    getAddress.mutate(profile);
  }, []);

  useEffect(() => {
    if (entities.state.get('address').count() >= 1) {
      setAddress(entities.state.get('address').last());
    }
  }, [entities.state.get('address')]);

  const onChange = e => {
    e.preventDefault();

    setProfile(profile.set(e.target.name, e.target.value));
  }

  const onChangeAddress = e => {
    e.preventDefault();

    setAddress(address.set(e.target.name, e.target.value));
  }

  const save = () => {
    const normalizedProfile = profile
      .set('first_name', toTitleCase(profile.first_name))
      .set('last_name', toTitleCase(profile.last_name))
      .set('email', profile.email.toLowerCase().trim());

    const normalizedAddress = address
      ?.set('address1', toTitleCase(address.address1))
      .set('address2', toTitleCase(address.address2))
      .set('city', toTitleCase(address.city))
      .set('state', address.state.toUpperCase().trim());

    updateAccount.mutate(normalizedProfile);
    updateAddress.mutate(normalizedAddress);

    if (updateAccount.isSuccess) user.setUser(normalizedProfile);
    setUpdated(true);
    setTimeout(() => setUpdated(false), 5000);
  }

  return (
    <div>
      {updated && <div className="notification is-success">Profile updated!</div>}
      <div className="field">
        <label className="label">First Name <span style={{ color: 'red' }}>*</span></label>
        <div className="control">
          <input className="input" type="text" name="first_name" onChange={onChange} value={profile.first_name} />
          {errors.first_name && <div className="has-text-danger has-text-weight-semibold">{errors.first_name}</div>}
        </div>
      </div>

      <div className="field">
        <label className="label">Last Name <span style={{ color: 'red' }}>*</span></label>
        <div className="control">
          <input className="input" type="text" name="last_name" onChange={onChange} value={profile.last_name} />
          {errors.last_name && <div className="has-text-danger has-text-weight-semibold">{errors.last_name}</div>}
        </div>
      </div>

      <div className="field">
        <label className="label">Email <span style={{ color: 'red' }}>*</span></label>
        <div className="control">
          <input className="input" type="text" name="email" onChange={onChange} value={profile.email} />
          {errors.email && <div className="has-text-danger has-text-weight-semibold">{errors.email}</div>}
        </div>
      </div>

      <div className="field">
        <label className="label">Phone</label>
        <div className="control">
          <input
            className="input"
            type="text"
            name="phone"
            mask="(999) 999-9999"
            onChange={onChange}
            value={formatPhone(profile.phone)}
          />
          {errors.phone && <div className="has-text-danger has-text-weight-semibold">{errors.phone}</div>}
        </div>
      </div>

      <div className="field">
        <label className="label">Mailing Address Line 1 <span style={{ color: 'red' }}>*</span></label>
        <div className="control">
          <input className="input" type="text" name="address1" onChange={onChangeAddress} value={address?.address1} />
          {errors.address1 && <div className="has-text-danger has-text-weight-semibold">{errors.address1}</div>}
        </div>
      </div>

      <div className="field">
        <label className="label">Address Line 2</label>
        <div className="control">
          <input className="input" type="text" name="address1" onChange={onChangeAddress} value={address?.address2} />
        </div>
      </div>

      <div className="field">
        <label className="label">City <span style={{ color: 'red' }}>*</span></label>
        <div className="control">
          <input className="input" type="text" name="city" onChange={onChangeAddress} value={address?.city} />
          {errors.city && <div className="has-text-danger has-text-weight-semibold">{errors.city}</div>}
        </div>
      </div>

      <div className="columns">
        <div className="column is-narrow">
          <div className="field">
            <label className="label">State <span style={{ color: 'red' }}>*</span></label>
            <div className="control">
              <input className="input" type="text" name="state" onChange={onChangeAddress} value={address?.state} />
              {errors.state && <div className="has-text-danger has-text-weight-semibold">{errors.state}</div>}
            </div>
          </div>
        </div>
        <div className="column">
          <div className="field">
            <label className="label">Postal Code <span style={{ color: 'red' }}>*</span></label>
            <div className="control">
              <input className="input" type="text" name="zip" onChange={onChangeAddress} value={address?.zip} />
              {errors.zip && <div className="has-text-danger has-text-weight-semibold">{errors.zip}</div>}
            </div>
          </div>
        </div>
      </div>

      <button className="button is-link" onClick={save} disabled={updateAccount.isLoading || updateAddress.isLoading}>Save</button>
    </div>
  )
}
